import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { crmApi } from "../lib/crm";

const CRMSettingsContext = createContext({ settings: null, refresh: () => {} });

export function CRMSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await crmApi.get("/settings");
      setSettings(r.data);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.error("[CRMSettings] refresh failed:", err);
      }
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <CRMSettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </CRMSettingsContext.Provider>
  );
}

export function useCRMSettings() {
  return useContext(CRMSettingsContext);
}

// Returns localized stage label respecting custom overrides
export function useStageLabel() {
  const { settings } = useCRMSettings();
  return (stage, lang, fallback) => {
    if (!settings) return fallback;
    const key = lang === "es" ? "stage_labels_es" : "stage_labels_en";
    const custom = settings[key]?.[stage];
    return custom || fallback;
  };
}
